import { useDroppable } from '@dnd-kit/core';
import { createId } from '@lmt/unicorn-shared/app/helpers/create-id';
import clsx from 'clsx';
import React, { FC, useMemo } from 'react';
import { DragObject } from '../common';

import styles from './DragAndDropPatient.module.scss';

export const CalendarDateCellDropHandler: FC<
  React.PropsWithChildren<{
    startDate: Date;
    endDate: Date;
    resource?: number;
  }>
> = React.memo(function CalendarDateCellDropHandler(props) {
  const id = useMemo(() => createId(), []);
  const droppable = useMemo(
    () => ({
      id: id,
      data: {
        type: 'calendar-cell',
        startDate: props.startDate,
        endDate: props.endDate,
        resource: props.resource,
      } as DragObject,
    }),
    [],
  );
  const { setNodeRef, isOver } = useDroppable(droppable);

  return (
    <div
      ref={setNodeRef}
      className={clsx(styles.dropHandler, isOver && styles.dropHandlerHover)}
    >
      {props.children}
    </div>
  );
});
